// courses/course_S03.ts

export const course_S03 = `
  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">1. 행사 현장 도착 전: "현장을 머릿속으로 그리세요"</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">사고는 예고 없이 찾아오지만, 준비된 매니저는 사고를 피할 수 있습니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>사전 답사 및 위성 지도 확인:</strong> 행사장의 출입구 위치, 차량 진입로, 무대까지의 거리를 미리 파악합니다.</li>
      <li style="margin-bottom: 8px;"><strong>경호 팀과의 협의:</strong> 대규모 행사의 경우 사설 경호 업체나 주최 측 보안 요원과 아티스트의 하차 지점 및 이동 경로를 사전에 맞춥니다.</li>
      <li><strong>비상 탈출로 확보:</strong> 만약의 사태를 대비해 무대에서 가장 빠르게 차량으로 복귀할 수 있는 최단 경로를 미리 확인해 둡니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">2. 이동 동선 관리: "아티스트를 감싸는 방패"</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">팬들이 몰리는 이동 구간은 매니저가 가장 긴장해야 하는 순간입니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>밀착 보호:</strong> 아티스트의 앞과 뒤, 옆을 적절히 막아 팬들이 신체 접촉을 하거나 길을 막지 못하게 유도합니다.</li>
      <li style="margin-bottom: 8px;"><strong>단호하지만 예의 바른 통제:</strong> "밀지 마세요", "위험합니다, 뒤로 물러나 주세요"라고 명확하고 큰 소리로 안내하여 인파 사고를 방지합니다. 이때 팬들에게 반말이나 과격한 행동을 하지 않도록 주의합니다.</li>
      <li><strong>차량 승하차 시 주의:</strong> 문을 열기 전 주변 상황을 살피고, 아티스트가 내린 직후에는 즉시 문을 닫아 외부인이 차량 내부를 들여다보거나 물건을 던져 넣지 못하게 합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">3. 현장 통제와 돌발 상황 대처</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>무대 난입 방지:</strong> 공연 중 흥분한 팬이 무대로 올라오려 할 경우, 무대 밑에서 즉시 차단하거나 무대 위 아티스트를 안전한 곳으로 이동시킵니다.</li>
      <li style="margin-bottom: 8px;"><strong>선물 및 편지 수거:</strong> 팬들이 던지는 선물에 아티스트가 맞지 않도록 주의하며, 직접 받기 어려운 상황에서는 나중에 정중히 수거하겠다고 안내합니다.</li>
      <li><strong>퇴근길 관리:</strong> 공연이 끝난 후 차량 주위를 에워싸는 팬들이 다치지 않게 서서히 차량을 이동시키며, 창문을 열어 인사하는 타이밍은 안전이 확보된 후에만 결정합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">4. 온라인 및 디지털 안전 관리</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>위치 정보 노출 주의:</strong> 이동 중인 차량 내부 사진이나 현재 위치가 드러나는 사진을 실시간 SNS에 올리지 않도록 주의합니다. (사생 팬 등의 추적 방지)</li>
      <li><strong>비공식 스케줄 보안:</strong> 공식적인 행사가 아닌 개인 일정 이동 시에는 동선이 노출되지 않도록 더욱 철저히 보안을 유지합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">5. 왜 안전 관리가 매니저의 실력인가?</h4>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>아티스트의 신뢰:</strong> 안전하게 지켜준다는 믿음이 있을 때 아티스트는 무대에서 최고의 퍼포먼스를 보여줄 수 있습니다.</li>
      <li><strong>회사의 리스크 방지:</strong> 인파 사고는 인명 피해와 브랜드 이미지 추락으로 이어집니다. 매니저의 철저한 통제는 회사의 가장 큰 자산을 지키는 일입니다.</li>
    </ul>
  </div>

  <div style="background-color: #f0f9ff; padding: 20px; border-radius: 12px; border-left: 5px solid #0284c7; margin-top: 30px;">
    <strong style="color: #0369a1; font-size: 1.1rem; display: block; margin-bottom: 10px;">💡 교육생을 위한 한 줄 요약</strong>
    <p style="margin: 0; color: #334155; font-style: italic; line-height: 1.6;">
      "매니저는 팬과 아티스트 사이의 가장 안전한 벽이자, 모두가 즐거운 축제를 완성하는 마지막 파수꾼입니다."
    </p>
  </div>
`;